import { observable, action, makeObservable } from 'mobx';
import {
    getInviteInfo,
    verifyInfo,
    bindAccount,
    improveInfo,
    handleByTypeConfig,
    getOrgListReq,
    getCustomInviteInfo,
    checkInviteInfoReq,
    getInviteOrgListReq
} from '@/api/org_invite_student';
import { improveInfoDetail } from '@/api/student_invite';
import message from '@/components/Toast';

class OrgInviteStudent {
    constructor() {
        makeObservable(this);
    }

    @observable
    auth_token = '';

    @observable
    org_info = {};

    @observable
    invite_flag = false;

    @action
    setInviteFlag(result) {
        this.invite_flag = result;
    }

    @action
    setOrgInfo(info) {
        this.org_info = info;
    }

    @action
    setAuthToken(token) {
        this.auth_token = token;
    }

    @observable
    invite_info = {};

    @action
    setInviteInfo(info) {
        this.invite_info = info;
    }

    getInviteInfo = async (tenantId) => {
        const { data, msg, code } = await getInviteInfo({
            headers: {
                TenantId: tenantId
            }
        });
        if (code === '00000') {
            this.setInviteInfo(data);
        } else if (code === 'A1806') {
            this.setInviteInfo({});
            return null;
        } else {
            this.setInviteInfo({});
            message.error(msg);
        }
    };

    getCustomInviteInfo = async (org_id, tenantId) => {
        this.setSubmit0(true);
        const { data, code } = await getCustomInviteInfo(org_id, {
            headers: {
                TenantId: tenantId
            }
        });

        if (code === '00000') {
            this.setInviteInfo(data);
        } else {
            this.setSubmit0(false);
            this.setInviteInfo({});
            message.error('组织码已失效');
        }
    };
    verifyIdentity = async (form, tenantId) => {
        const { msg, code, data } = await verifyInfo(form, {
            headers: {
                TenantId: tenantId
            }
        });
        if (code === '00000') {
            this.setAuthToken(data);
            return data;
        }
        return message.error(msg);
    };
    bindAccount = async (form, tenantId) => {
        const { msg, code, data } = await bindAccount(form, {
            headers: {
                TenantId: tenantId
            }
        });
        if (code === '00000') {
            if (!data.auth_token) {
                this.setInviteFlag(true);
                this.setOrgInfo(data);
                return data;
            }
            this.setOrgInfo(data);
            if (this.byTypeConfig.student_application_type === 1) return;
            const result = await this.improveInfoDetail({ auth_token: data.auth_token }, tenantId);
            return result;
        } else if (code === 'A1811' || code === 'A1803' || code === 'A1804') {
            message.error(msg);
            return null;
        }
        message.error(msg);
        return false;
    };

    @observable
    improve_info = {};

    @action
    setImproveInfo(info) {
        this.improve_info = info;
    }

    @observable
    isLoading = false;

    @action
    setIsLoading(result) {
        this.isLoading = result;
    }

    improveInfoDetail = async (form, tenantId) => {
        const { msg, code, data } = await improveInfoDetail(form, {
            headers: {
                TenantId: tenantId
            }
        });
        if (code === '00000') {
            this.setImproveInfo(data);
            return data;
        }
        return message.error(msg);
    };

    improveInfo = async (form, tenantId) => {
        this.setIsLoading(true);
        const { msg, code, data } = await improveInfo(form, {
            headers: {
                TenantId: tenantId
            }
        });
        if (code === '00000') {
            this.setInviteFlag(true);
            this.setOrgInfo(data);
            this.setIsLoading(false);
        } else {
            this.setIsLoading(false);
            return message.error(msg);
        }
    };
    @observable
    byTypeConfig = {};

    @action
    setByTypeConfig(data) {
        this.byTypeConfig = { ...data };
    }

    handleByTypeConfigFunc = async (tenantId) => {
        let res = await handleByTypeConfig(
            { type: 'student_application_type' },
            {
                headers: {
                    TenantId: tenantId
                }
            }
        );
        if (res?.code === '00000') {
            this.setByTypeConfig(res.data);
            return res.data;
        }
        return message.error(res?.msg);
    };

    getOrgList = async (tenantId) => {
        let res = await getOrgListReq(
            {},
            {
                headers: {
                    TenantId: tenantId
                }
            }
        );
        if (res?.code === '00000') {
            return res.data;
        }
        return message.error(res?.msg);
    };

    @observable
    submit0 = true;

    @action
    setSubmit0(result) {
        this.submit0 = result;
    }

    getInviteOrgList = async (tenantId, codeId, studentApplicationType) => {
        let res = await getInviteOrgListReq(
            { tenant_id: tenantId, code_id: codeId, student_application_type: studentApplicationType },
            {
                headers: {
                    TenantId: tenantId
                }
            }
        );
        if (res?.code === '00000') {
            return res.data;
        }
        return message.error(res?.msg);
    };
    checkInviteInfo = async (tenantId, codeId, studentApplicationType) => {
        const { msg, code } = await checkInviteInfoReq(
            { tenant_id: tenantId, code_id: codeId, student_application_type: studentApplicationType },
            {
                headers: {
                    TenantId: tenantId
                }
            }
        );

        if (code === '00000') {
            return true;
        } else if (code === 'A1831') {
            return null;
        }
        message.error(msg);
    };
}

const orgInviteStudent = new OrgInviteStudent();
export default orgInviteStudent;
